// 禁言菜单
import { publicApi, request } from 'lib';
import { UiToast } from 'components';
import { useBoolean } from 'react-hanger';
import { useEffect } from 'react';
import { auth } from '@/modules/widgets/lib';

const MenuShutUp = (props) => {
  const { userId, roomId } = props;
  const handle = (e) => {
    const { minutes } = e.currentTarget.dataset;
    request.cryolite
      .post('api/v2/privileges/shutup', {
        to_id: userId,
        room_id: roomId,
        minutes,
      })
      .then((res) => {
        UiToast.success('禁言成功');
      })
      .catch((res) => {
        UiToast.fail(res.msg);
      });
  };

  return (
    <li>
      <span>禁言</span>
      <i className="mc-font mc-more"></i>
      <ul>
        <li data-minutes={5} onClick={handle}>
          5分钟
        </li>
        <li data-minutes={10} onClick={handle}>
          10分钟
        </li>
        {/* <li>本场</li> */}
      </ul>
    </li>
  );
};

const MenuKickOut = (props) => {
  const { userId, roomId } = props;

  const handle = (e) => {
    const { minutes } = e.currentTarget.dataset;
    request.cryolite
      .post('api/v2/privileges/kick', {
        to_id: userId,
        room_id: roomId,
        minutes,
      })
      .then((res) => {
        UiToast.success('踢出房间成功');
      })
      .catch((res) => {
        UiToast.fail(res.msg);
      });
  };

  return (
    <li>
      <span>踢出</span>
      <i className="mc-font mc-more"></i>
      <ul>
        <li data-minutes={5} onClick={handle}>
          5分钟
        </li>
        <li data-minutes={10} onClick={handle}>
          10分钟
        </li>
        {/* <li>本场</li> */}
      </ul>
    </li>
  );
};

// 设为管理
const MenuAdmin = (props) => {
  const { userId, roomId } = props;
  const isAdmin = useBoolean(false);

  useEffect(() => {
    request.cryolite
      .get('api/v1/room/admin', {
        uid: userId,
        room_id: roomId,
      })
      .then((res) => {
        isAdmin.setValue(res.data.result);
      });
  }, []);

  const addAdmin = () => {
    request.api
      .get(`room/add_admin/{access_token}/${roomId}/${userId}`)
      .then((res) => {
        UiToast.success('已设置为管理员');
      })
      .catch((res) => {
        UiToast.fail(res.msg || '操作失败');
      });
  };
  const delAdmin = () => {
    request.api
      .get(`room/del_admin/{access_token}/${roomId}/${userId}`)
      .then((res) => {
        UiToast.success('已取消管理员');
      })
      .catch((res) => {
        UiToast.fail(res.msg || '操作失败');
      });
  };
  if (isAdmin.value) {
    return <li onClick={delAdmin}>取消管理员</li>;
  }
  return <li onClick={addAdmin}>设为管理员</li>;
};

// 设为荣耀粉丝
const MenuHonourFans = (props) => {
  const { userId, honorFans } = props;

  function setHonourFans() {
    const setText = !honorFans ? '设置' : '解除';
    request.cryolite
      .get('/api/v1/honorUser/addOrDel', {
        uid: userId,
        type: honorFans ? 2 : 1,
      })
      .then((res) => {
        UiToast.success(`“荣耀粉丝”${setText}成功，剩余可设置名额${res.data.surplus}个`);
      })
      .catch((err) => {
        UiToast.fail(err.msg || `“荣耀粉丝”${setText}失败`);
      });
  }
  if (honorFans) {
    return <li onClick={setHonourFans}>解除荣耀粉丝</li>;
  }
  return <li onClick={setHonourFans}>设为荣耀粉丝（7天）</li>;
};

//  派对禁言
const PartyMute = (props) => {
  const { userId } = props;
  const handle = () => {
    auth.handleHostOperator('shutup', userId);
  };

  return (
    <li onClick={handle}>
      <span>禁言</span>
    </li>
  );
};

// 派对拉黑
const PartyBlack = (props) => {
  const { userId } = props;
  const handle = () => {
    auth.handleHostOperator('block', userId);
  };

  return (
    <li onClick={handle}>
      <span>拉黑</span>
    </li>
  );
};

// 派对踢人
const PartyKick = (props) => {
  const { userId } = props;
  const handle = () => {
    auth.handleHostOperator('kick', userId);
  };

  return (
    <li onClick={handle}>
      <span>踢出</span>
    </li>
  );
};

export { MenuShutUp, MenuKickOut, MenuAdmin, PartyMute, PartyKick, PartyBlack, MenuHonourFans };
